import { render } from "./YazamData.vue?vue&type=template&id=55908449&scoped=true"
import script from "./YazamData.vue?vue&type=script&lang=js"
export * from "./YazamData.vue?vue&type=script&lang=js"

import "./YazamData.vue?vue&type=style&index=0&id=55908449&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55908449"]])

export default __exports__